import { Button, Grid } from '@material-ui/core';
import * as React from 'react';

const SheetJSFT = [
  'xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv',
].map((x) => `.${x}`).join(',');

const ImportInput: React.FC<{
  handleFile: (file: File) => void,
}> = (
  {
    handleFile,
  },
) => {
  const onChange = (event: React.ChangeEvent) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const target = event.target as HTMLInputElement;
    const file = target?.files?.[0];
    if (file) handleFile(file);
  };

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12} />
      <Grid item xs={12}>
        <input
          id="file-upload"
          type="file"
          accept={SheetJSFT}
          onChange={onChange}
          className="form-control"
          hidden
          value=""
        />
        <Button color="primary" variant="contained" component="label" htmlFor="file-upload">
          {'Select File (.xlsx, .csv)'}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          disableTouchRipple
          disableElevation
          disableRipple
          disableFocusRipple
          tabIndex={0}
          color="primary"
        >
          {'DRAG AND DROP FILE HERE TO UPLOAD'}
        </Button>
      </Grid>
      <Grid item xs={12} />
    </Grid>
  );
};
export default ImportInput;
